<main class="content">
  <section class="two-column-section bg-white">
    <div class="container">
      <h2 class="section-title">
        Aqui, talento se transforma em oportunidade. Torne-se um Broader!
      </h2>
      <div class="two-column-wrapper">
        <div class="text-content">
          <p>
            Faça parte de uma equipe que valoriza inovação, crescimento e
            pessoas que transformam desafios em oportunidades.
            <br /><br />
            <strong>
              Venha construir o futuro do mercado financeiro com a
              gente!</strong
            >
          </p>
        </div>
        <div class="image-content">
          <img
            src="../../../assets/img/png/carreiras.png"
            alt="Duas mulheres e um homem trabalhando de diferentes lugares"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-gray">
    <div class="container">
      <div class="two-column-wrapper">
        <div class="text-content">
          <h2 class="section-title">Vagas ativas</h2>
          <button
            style="color: #cc3179"
            mat-stroked-button
            class="linkedin-button"
            onclick="window.open('https://br.linkedin.com/company/broadfactor')"
          >
            Candidate-se pelo LinkedIn
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-white">
    <div class="container">
      <h2 class="section-title">Sobre a Broadfactor e a cultura</h2>
      <p>
        Na <strong> Broadfactor,</strong> cultivamos um ambiente leve, produtivo
        e diversificado, onde ideias transformadoras são compartilhadas.
        <strong>
          Nosso compromisso é construir um futuro próspero para todas as
          empresas que confiam em nossas soluções financeiras.
        </strong>
      </p>
      <div class="two-column-wrapper">
        <div class="text-content">
          <p>
            Valorizamos o crescimento colaborativo, entendemos necessidades
            especiais e na medida do possível nos empenhamos em atendê-las.
            <strong>
              Nossos Broaders equilibram produtividade e bem-estar.</strong
            >
          </p>
        </div>
        <div class="image-content">
          <img
            class="hidden-mobile"
            src="../../../assets/img/png/mundo.png"
            alt="Ilustração - Nossa visão"
          />
        </div>
      </div>
      <p>
        Juntos, construímos histórias de sucesso e transformamos desafios em
        conquistas.
      </p>
    </div>
  </section>

  <section class="teams-section bg-gray">
    <div class="container">
      <h2 class="section-title">Conheça os times da Broadfactor</h2>
      <div class="teams-container">
        <div class="team-card">
          <img
            src="../../../assets/img/png/Vector (8).png"
            alt="Ícone Marketing"
          />
          <h3>Marketing</h3>
          <p>
            Responsável por toda a identidade visual da Broadfactor, bem como
            toda a parte estratégica e funcional do marketing digital.
          </p>
        </div>
        <div class="team-card">
          <img
            src="../../../assets/img/png/Vector (9).png"
            alt="Ícone Customer Success"
          />
          <h3>Customer Success</h3>
          <p>
            Responsável pelo atendimento, vendas de títulos, acompanhamento e
            suporte nas operações do início ao fim do processo.
          </p>
        </div>
        <div class="team-card">
          <img
            src="../../../assets/img/png/Vector (7).png"
            alt="Ícone Tecnologia"
          />
          <h3>Tecnologia</h3>
          <p>
            Responsável por desenvolver e manter nossas plataformas atualizadas,
            funcionais e intuitivas, para que os times e clientes possam
            utilizá-las.
          </p>
        </div>
        <div class="team-card">
          <img src="../../../assets/img/png/people_alt.png" alt="Ícone DHO" />
          <h3>DHO</h3>
          <p>
            Responsável pelo recrutamento de novos Broaders, cultura,
            engajamento e aprimoramento de colaboradores, juntamente com os
            líderes.
          </p>
        </div>
        <div class="team-card">
          <img
            src="../../../assets/img/png/Vector (11).png"
            alt="Ícone Comercial"
          />
          <h3>Comercial</h3>
          <p>
            Responsável por apresentar a Broadfactor aos futuros cedentes e
            financiadores. Cuida da qualificação inicial, aprovação de crédito e
            fidelização.
          </p>
        </div>
        <div class="team-card">
          <img
            src="../../../assets/img/png/Vector (10).png"
            alt="Ícone Adm/Financeiro"
          />
          <h3>Adm/Financeiro</h3>
          <p>
            Responsável pelo controle financeiro das operações e pela gestão das
            contas dos clientes, garantindo organização e eficiência.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="differentials-section bg-white">
    <div class="container">
      <h2 class="section-title">Diferenciais</h2>
      <div class="differentials-wrapper">
        <div class="differentials-icons">
          <div class="differential-item">
            <img
              src="../../../assets/img/png/Ellipse 3.png"
              alt="Ambiente leve"
            />
            <strong>Ambiente leve e descontraído</strong>
          </div>
          <div class="differential-item">
            <img
              src="../../../assets/img/png/Ellipse 4.png"
              alt="Crescimento"
            />
            <strong>Crescimento e desenvolvimento</strong>
          </div>
          <div class="differential-item">
            <img
              src="../../../assets/img/png/Ellipse 6.png"
              alt="Experiência Startup"
            />
            <strong>Experiência Startup</strong>
          </div>
          <div class="differential-item">
            <img
              src="../../../assets/img/png/Ellipse 7.png"
              alt="Day-off aniversário"
            />
            <strong>Day-off de aniversário</strong>
          </div>
          <div class="differential-item">
            <img
              src="../../../assets/img/png/Ellipse 8 (1).png"
              alt="Ambiente inclusivo"
            />
            <strong>Ambiente inclusivo</strong>
          </div>
        </div>
        <div class="differentials-text">
          <p>
            Nós fazemos o trabalho e fazemos bem feito, tudo isso em um ambiente
            saudável, com um time que se apoia, chega junto e se diverte.
          </p>
          <p>
            Os broaders crescem com a empresa. Estamos em expansão e temos
            muitas oportunidades para nossos colaboradores.
          </p>
          <p>
            Nossos broaders adquirem experiência de destaque no setor
            financeiro, vivenciando o dia a dia de uma startup em constante
            crescimento.
          </p>
          <p>
            Para comemorar, cada broader recebe de presente um dia livre no mês
            do seu aniversário.
          </p>
          <p>
            Nosso ambiente é diverso e inclusivo. Todos os broaders são bem
            acolhidos e fazem parte da família Broadfactor.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-gray">
    <div class="container">
      <h2 class="section-title">LGPD</h2>
      <div class="two-column-wrapper mobile-reverse-column">
        <div class="text-content">
          <p>
            A Broadfactor adota uma política para garantir controle e
            transparência no tratamento de dados de todas as pessoas, inclusive
            aquelas interessadas em fazer parte do nosso time. As informações de
            candidatos à vagas abertas durante o processo seletivo e de
            candidatos cadastrados no banco de talentos são tratadas
            rigorosamente de acordo com a LGPD.
          </p>
          <p>
            O compartilhamento desses dados ocorrerá apenas com colaboradores da
            Broadfactor que estejam diretamente envolvidos no processo,
            terceiros e parceiros de negócios que sejam relevantes para o
            processo de recrutamento e seleção.
          </p>
          <p>
            A Broadfactor irá manter o armazenamento dos dados do candidato por
            aproximadamente um (1) ano, ou o tempo necessário para realização do
            processo de seleção. E sempre que desejar, o candidato pode
            solicitar a exclusão dos seus dados do nosso banco de talentos. Caso
            ainda tenha dúvidas relacionadas à LGPD, você pode entrar em contato
            com alguém da nossa equipe através do e-mail
            <strong> suporte&#64;broadfactor.com.</strong>
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-white">
    <h2 class="section-title">Banco de talentos. Faça seu cadastro</h2>
    <div class="container">
      <div class="two-column-wrapper">
        <div class="text-content">
          <form #form="ngForm" class="form" [formGroup]="formCliente">
            <app-feedback
              *ngIf="clickedButton"
              [sendedMail]="sendedMail"
            ></app-feedback>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput required formControlName="name" />
              <mat-error *ngIf="formCliente.get('name')?.hasError('required')">
                Nome é obrigatório.
              </mat-error>
            </mat-form-field>

            <table class="full-width" cellspacing="0">
              <tr>
                <td style="padding-right: 8px">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Telefone</mat-label>
                    <input
                      matInput
                      mask="(00) 00000-0000"
                      required
                      formControlName="phone"
                    />
                    <mat-error
                      *ngIf="formCliente.get('phone')?.hasError('required')"
                    >
                      Telefone é obrigatório.
                    </mat-error>
                  </mat-form-field>
                </td>

                <td style="padding-right: 8px">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>LinkedIn</mat-label>
                    <input matInput required formControlName="linkedIn" />
                    <mat-error
                      *ngIf="formCliente.get('linkedIn')?.hasError('required')"
                    >
                      LinkedIn é obrigatório.
                    </mat-error>
                  </mat-form-field>
                </td>

                <td>
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Selecione uma área</mat-label>
                    <mat-select required formControlName="candidacy">
                      <mat-option value="marketing">Marketing</mat-option>
                      <mat-option value="marketing"
                        >Custumer Success</mat-option
                      >
                      <mat-option value="marketing">Tecnologia</mat-option>
                      <mat-option value="marketing"
                        >Desenvolvimento humano e organizacional</mat-option
                      >
                      <mat-option value="marketing">Comercial</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="formCliente.get('candidacy')?.hasError('required')"
                    >
                      Selecione uma área.
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
            </table>

            <p>
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>E-mail</mat-label>
                <input matInput required formControlName="email" />
                <mat-error
                  *ngIf="formCliente.get('email')?.hasError('required')"
                >
                  E-mail é obrigatório.
                </mat-error>
                <mat-error *ngIf="formCliente.get('email')?.hasError('email')">
                  Insira um e-mail válido.
                </mat-error>
              </mat-form-field>
            </p>

            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Mensagem</mat-label>
              <textarea matInput required formControlName="msg"></textarea>
              <mat-error *ngIf="formCliente.get('msg')?.hasError('required')">
                Mensagem é obrigatória.
              </mat-error>
            </mat-form-field>

            <mat-checkbox
              formControlName="acceptedTerms"
              (click)="checkbox()"
              color="primary"
              class="terms-checkbox"
            >
              Eu li e aceito os termos de privacidade da Broadfactor.
            </mat-checkbox>
            <mat-error
              *ngIf="formCliente.get('acceptedTerms')?.hasError('requiredTrue')"
            >
              Você precisa aceitar os termos.
            </mat-error>
            <mat-chip-listbox aria-label="Color selection">
              <mat-chip-option *ngIf="file">
                {{ file.name }}
                <mat-icon (click)="removeDocument()" class="close-icon"
                  >close</mat-icon
                >
              </mat-chip-option>
            </mat-chip-listbox>
            <div
              style="margin-top: 20px; display: flex; align-items: flex-start"
            >
              <div
                style="
                  margin-right: 10px;
                  display: flex;
                  flex-direction: column;
                "
              >
                <input
                  #attachFile
                  hidden="true"
                  formControlName="file"
                  type="file"
                  (change)="csvInputChange($event)"
                />
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="attachFile.click()"
                >
                  <mat-icon>attach_file</mat-icon> Anexar Currículo
                </button>
              </div>
              <button
                mat-flat-button
                color="primary"
                [disabled]="!formCliente.valid"
                (click)="send()"
              >
                @if (isLoading){
                <mat-spinner diameter="20"></mat-spinner>
                } @else{ Enviar}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</main>
